import axios from "@/axios"

const url = "/api/brain/tournament/knives/"

class TournamentKnivesService {
	async getKnives(params) {
		const { data } = await axios.get(`${url}`, { params })
		return data
	}

	async getCodesList() {
		const { data } = await axios.get(`${url}codes-list`)
		return data
	}

	async getCodes() {
		const { data } = await axios.get(`${url}codes`)
		return data
	}

	async getSeries(code) {
		const { data } = await axios.get(`${url}series`, { params: { code } })
		return data
	}

	async saveKnife(body) {
		const data = await axios.post(`${url}`, body)
		return data
	}
	async updateStatus(id, body) {
		const { data } = await axios.patch(`${url}${id}/status`, body)
		return data
	}
	async updateDescription(id, body) {
		const { data } = await axios.patch(`${url}${id}/description`, body)
		return data
	}
	async assignKnife(body) {
		const data = await axios.post(`${url}assign`, body)
		return data
	}
	async getHistory(id) {
		const { data } = await axios.get(`${url}${id}/history`)
		return data
	}
	async getActives(params) {
		const { data } = await axios.get(`${url}actives`, { params })
		return data
	}
}
export default new TournamentKnivesService()
